import { render } from "./ComparisonStoresItem.vue?vue&type=template&id=68f575db&scoped=true"
import script from "./ComparisonStoresItem.vue?vue&type=script&lang=js"
export * from "./ComparisonStoresItem.vue?vue&type=script&lang=js"

import "./ComparisonStoresItem.vue?vue&type=style&index=0&id=68f575db&lang=scss&scoped=true"
import "./ComparisonStoresItem.vue?vue&type=style&index=1&id=68f575db&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f575db"]])

export default __exports__